/* @flow */
import * as React from 'react';
import UserAnalyticsService from 'common/services/UserAnalyticsService';
import ProductTrackerService from 'common/services/ProductTrackerService';
import {
    onPageLoadStart,
    onPageLoadEnd
} from 'common/middleware/PerformanceTracker';
import {
    getPageNameFromUrl,
    getQueryParams,
    hasPageChanged
} from 'common/utils/URLUtils';

import { type ProductType } from 'common/enums/Product';

const withRouteTracker = <TProps: { match: $FixMe }>(
    Component: React.AbstractComponent<TProps>,
    product: ProductType
): React.AbstractComponent<TProps> => {
    return class ComponentWithRouteTracker extends React.PureComponent<TProps> {
        constructor(props) {
            super(props);
            ProductTrackerService.setActiveProduct(product);
            onPageLoadStart();
        }

        componentDidMount = () => {
            const { match } = this.props;
            UserAnalyticsService.setPage(match.path);
        };

        UNSAFE_componentWillReceiveProps(nextProps) {
            const { location: nextLocation, match: nextMatch } = nextProps;
            const { location } = this.props;
            const query = getQueryParams(location);
            const nextQuery = getQueryParams(nextLocation);
            if (
                (location.pathname !== nextLocation.pathname ||
                    location.search !== nextLocation.search) &&
                hasPageChanged(query, nextQuery, nextMatch)
            ) {
                // Trigger onPageLoadStart on change in URL since page has changed
                onPageLoadStart();
            }
        }

        componentDidUpdate = nextProps => {
            const { match } = this.props;
            const { match: nextMatch } = nextProps;
            if (match.url !== nextMatch.url) {
                UserAnalyticsService.setPage(match.path);
            }
        };

        onPageLoadEnd = () => {
            const { match, location } = this.props;
            const { clientId } = match.params;
            const queryParams = getQueryParams(location);
            const pageName = getPageNameFromUrl(match, queryParams);
            onPageLoadEnd({ clientId, pageName });
        };

        render() {
            return (
                <Component
                    {...this.props}
                    onContentLoaded={this.onPageLoadEnd}
                />
            );
        }
    };
};
export default withRouteTracker;
